module.exports = __webpack_public_path__ + "static/image/help_center_common_question.svg?1471696b8dbfe1a7b93469af54f66c65";